import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'

const STYLES = {
	header: {
		fontWeight: 200,
		fontSize: 22,
		lineHeight: '30px',
		textAlign: 'center',
		fontFamily: 'pp-sans-big-regular',
		marginTop: 0,
		marginBottom: 0
	}
}

class DebitOrCredit extends React.Component {
	render () {
		const guestMessages = localsMessages('guest/payCreditOrDebit') || {}
		const payCreditOrDebit = guestMessages.label && guestMessages.label.payCreditOrDebit || ''

		return (
			<div className="row" style={{ maxWidth: 400, margin: '0 auto' }}>
				<div className="col-xs-12 col-sm-12 col-md-12" style={{ padding: 0 }}>
					<p style={STYLES.header}>{payCreditOrDebit}</p>
				</div>
			</div>
		);
	}
}

DebitOrCredit.propTypes = {
	label: PropTypes.string
};

export default DebitOrCredit



// WEBPACK FOOTER //
// ./components/payCreditOrDebit.js